import type { SocieteRewardStatus } from '~/services/LuxLoyalty';

/**
 * The single source of truth for whether a Société flash-hotel reward is eligible: true for
 * `AUTO_ELIGIBLE` (the formula says redeemable) or `ADMIN_ELIGIBLE` (an admin forced it on).
 * Never compare `status` against a single string to decide eligibility elsewhere — an
 * admin-forced-eligible package has `computed_status = AUTO_INELIGIBLE`, so that shortcut gives
 * the wrong answer; always go through this helper instead.
 */
export function isSocieteRewardEligible(status: SocieteRewardStatus): boolean {
  return status === 'AUTO_ELIGIBLE' || status === 'ADMIN_ELIGIBLE';
}
